<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <!-- Header Section -->
            <div
              class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
            >
              <div class="flex items-center gap-2">
                <div>
                  <h2 class="text-2xl font-bold text-gray-800">
                    Batches
                    <span class="text-blues text-lg font-medium ml-2"
                      >({{ count_list || 0 }})</span
                    >
                  </h2>
                  <p class="text-sm text-gray-500 mt-0.5">
                    Manage and view all Batches
                  </p>
                </div>
              </div>
              <router-link :to="{ name: 'AdminDashboards' }">
                <button
                  class="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 px-4 rounded-xl transition-all duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Back to Dashboard
                </button>
              </router-link>
            </div>

            <!-- Search Section -->
            <div class="flex justify-end">
              <div class="relative w-full max-w-80">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="searching"
                  @input="searchUserValue(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Table Section -->
            <div v-if="batchs.length > 0" class="mt-2">
              <div
                class="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm"
              >
                <table class="min-w-full divide-y divide-gray-100">
                  <thead>
                    <tr class="bg-gray-100">
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold rounded-l-xl text-blues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> S.No </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold text-blues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1 justify-center">
                          Batch
                        </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold rounded-r-xl text-blues"
                      >
                        <span class="flex items-center gap-1 justify-center">
                          Students Count
                        </span>
                      </th>
                    </tr>
                  </thead>

                  <tbody class="divide-y divide-gray-50">
                    <template v-for="(list, index) in batchs" :key="index">
                      <!-- Main Row -->
                      <tr
                        class="hover:bg-blue-50/30 transition-all duration-150 group cursor-pointer"
                        @click="toggleExpand(list.id)"
                      >
                        <td
                          class="px-5 py-3.5 text-sm text-gray-500 font-medium border-r border-gray-200"
                        >
                          <span
                            class="inline-flex items-center justify-center w-7 h-7 bg-gray-100 rounded-lg text-xs font-semibold text-gray-600 group-hover:bg-blue-100 group-hover:text-blues transition"
                          >
                            {{ (currentPage - 1) * 10 + index + 1 }}
                          </span>
                        </td>

                        <td class="px-5 py-3.5 border-r border-gray-200">
                          <div class="flex items-center justify-center gap-2">
                            <span
                              class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 text-xs font-medium hover:text-blue-600"
                            >
                              {{ list.year || "---" }}
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4 text-gray-400 transition-transform duration-200"
                              :class="{
                                'rotate-180': expandedRows.includes(list.id),
                              }"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </td>

                        <td class="px-5 py-3.5 text-center">
                          <span class="font-medium text-gray-500 text-xs">{{
                            list.student_count || 0
                          }}</span>
                        </td>
                      </tr>

                      <!-- Expandable Row -->
                      <tr v-if="expandedRows.includes(list.id)">
                        <td colspan="3" class="px-0 py-0 bg-gray-50">
                          <div class="p-4 border-t border-gray-200">
                            <div class="grid grid-cols-1 md:grid-cols-1 gap-6">
                              <!-- Department Section -->
                              <div
                                class="bg-white rounded-xl border border-gray-200 overflow-hidden hidden"
                              >
                                <div
                                  class="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-200"
                                >
                                  <div class="flex items-center gap-2">
                                    <h4 class="font-semibold text-gray-800">
                                      Department-wise Count
                                    </h4>
                                  </div>
                                </div>
                                <div class="overflow-x-auto">
                                  <table
                                    class="min-w-full divide-y divide-gray-100"
                                  >
                                    <thead class="bg-gray-50">
                                      <tr>
                                        <th
                                          class="px-4 py-2 text-left text-xs font-medium text-gray-500"
                                        >
                                          Department
                                        </th>
                                        <th
                                          class="px-4 py-2 text-right text-xs font-medium text-gray-500"
                                        >
                                          Students
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-100">
                                      <tr
                                        v-for="dept in list.department_count"
                                        :key="dept.department_id"
                                        class="hover:bg-gray-50"
                                      >
                                        <td
                                          class="px-4 py-2 text-sm text-gray-700"
                                        >
                                          {{ dept.department_name }}
                                        </td>
                                        <td
                                          class="px-4 py-2 text-sm text-right"
                                        >
                                          <span
                                            class="inline-flex items-center justify-center px-2 py-0.5 rounded-full bg-blue-100 text-blues text-xs font-semibold"
                                          >
                                            {{ dept.student_count }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr
                                        v-if="
                                          !list.department_count ||
                                          list.department_count.length === 0
                                        "
                                      >
                                        <td
                                          colspan="2"
                                          class="px-4 py-4 text-center text-sm text-gray-400"
                                        >
                                          No department data available
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                              <!-- Program Section -->
                              <div
                                class="bg-white rounded-xl border border-gray-200 overflow-hidden"
                              >
                                <!-- <div
                                  class="bg-white px-4 py-3 border-b border-gray-200"
                                >
                                  <div class="flex items-center gap-2">
                                    <h4 class="font-semibold text-gray-800">
                                      Program-wise Count
                                    </h4>
                                  </div>
                                </div> -->
                                <div class="overflow-x-auto">
                                  <table
                                    class="min-w-full divide-y divide-gray-100"
                                  >
                                    <thead class="bg-gray-50">
                                      <tr>
                                        <th
                                          class="px-4 py-2 text-left text-xs font-medium text-gray-500"
                                        >
                                          Program
                                        </th>
                                        <th
                                          class="px-4 py-2 text-right text-xs font-medium text-gray-500"
                                        >
                                          Students
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-100">
                                      <tr
                                        v-for="prog in list.program_count"
                                        :key="prog.program_id"
                                        class="hover:bg-gray-50"
                                      >
                                        <td
                                          class="px-4 py-2 text-sm text-gray-700"
                                        >
                                          {{ prog.program_name }}
                                        </td>
                                        <td
                                          class="px-4 py-2 text-sm text-right"
                                        >
                                          <span
                                            class="inline-flex items-center justify-center px-2 py-0.5 rounded-full  text-gray-700 text-xs font-semibold"
                                          >
                                            {{ prog.student_count }}
                                          </span>
                                        </td>
                                      </tr>
                                      <tr
                                        v-if="
                                          !list.program_count ||
                                          list.program_count.length === 0
                                        "
                                      >
                                        <td
                                          colspan="2"
                                          class="px-4 py-4 text-center text-sm text-gray-400"
                                        >
                                          No program data available
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>

              <div class="mt-6">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="batchget"
                />
              </div>
            </div>

            <!-- Empty State -->
            <div
              v-else
              class="flex flex-col items-center justify-center py-16 bg-gray-50 rounded-2xl"
            >
              <div
                class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-10 w-10 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-700">
                No Batches Found
              </h3>
              <p class="text-sm text-gray-400 mt-1">
                Try adjusting your search or filter
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      batchs: [],
      count_list: "",
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",
      expandedRows: [], // Array to store expanded row IDs
    };
  },
  components: {
    SideBar,
    FlashMessage,
    Pagination,
  },
  async created() {
    await this.batchget(1);
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    async batchget(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-filter-list/?Key=${this.userInfo.token_key}&page=${page}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.batchs = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/batch-filter-list/?search=${this.searching}&Key=${this.userInfo.token_key}&page=${this.currentPage}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.batchs = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
          }
        });
    },
    clearSearch() {
      this.searching = "";
      this.batchget(1);
    },
    toggleExpand(batchId) {
      if (this.expandedRows.includes(batchId)) {
        this.expandedRows = this.expandedRows.filter((id) => id !== batchId);
      } else {
        this.expandedRows.push(batchId);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

/* Custom scrollbar */
.heightfix::-webkit-scrollbar {
  width: 6px;
}

.heightfix::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
